import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DataEndpoint } from '@core/models/general.model';
import { Observable, map } from 'rxjs';
import { ConversionModel } from '../models/conversion.model';

@Injectable({
  providedIn: 'root',
})
export class ConversionApi {
  private readonly http = inject(HttpClient);
  private readonly CONVERSION = '/Conversion';

  getConversion(): Observable<DataEndpoint<ConversionModel[]>> {
    const url = `${this.CONVERSION}`;

    return this.http.get<DataEndpoint<ConversionModel[]>>(url)
      .pipe(map((data: DataEndpoint<ConversionModel[]>) => {
        return {...data}
      })); 
  }
}
